export function isKenraColor(shopifyProductTags) {
    let colorTags = [
        'Color',
        'Kenra Color Permanent',
        'Kenra Color Demi',
        'Kenra Color',
    ];
    for (let tag of colorTags) {
        if (shopifyProductTags.includes(tag)) return true;
    }

    return false;
}

export function isKenraPlatinum(shopifyProductTags) {
    return shopifyProductTags.includes('Platinum');
}

const PRESERVE_CASE_WORDS = ['RoV', 'GrBl'];

export function formatProductTitle(title) {
    if (!title) return '';
    const pattern = new RegExp(`\\b(${PRESERVE_CASE_WORDS.join('|')})\\b`, 'gi');
    const parts = title.split(pattern);
    return parts.map(part => {
        const match = PRESERVE_CASE_WORDS.find(w => w.toLowerCase() === part.toLowerCase());
        return match || part.toUpperCase();
    }).join('');
}

export function getMetafield(shopifyProduct, name, defaultValue = null) {
    if (!shopifyProduct || !Array.isArray(shopifyProduct.metafields))
        return defaultValue;

    let field = shopifyProduct.metafields.find(mf => mf.key === name);
    if (field) return field.value;

    return defaultValue;
}
